import createIcon from '../../createIcon';

/**
 * @component @name LibraryMusic
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg4QzYuOSAyIDYgMi45IDYgNFYxNkM2IDE3LjEgNi45IDE4IDggMThIMjBDMjEuMSAxOCAyMiAxNy4xIDIyIDE2VjRDMjIgMi45IDIxLjEgMiAyMCAyWk0xOCA3SDE1VjEyLjVDMTUgMTMuODggMTMuODggMTUgMTIuNSAxNUMxMS4xMiAxNSAxMCAxMy44OCAxMCAxMi41QzEwIDExLjEyIDExLjEyIDEwIDEyLjUgMTBDMTMuMDcgMTAgMTMuNTggMTAuMTkgMTQgMTAuNTFWNUgxOFY3Wk00IDZIMlYyMEMyIDIxLjEgMi45IDIyIDQgMjJIMThWMjBINFY2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LibraryMusic = createIcon('LibraryMusic', [
  [
    'path',
    {
      d: 'M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM18 7H15V12.5C15 13.88 13.88 15 12.5 15C11.12 15 10 13.88 10 12.5C10 11.12 11.12 10 12.5 10C13.07 10 13.58 10.19 14 10.51V5H18V7ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z',
      key: '16hlgb',
    },
  ],
]);

export default LibraryMusic;
